/*
 * Compra de la landing de ebook. Los botones que en la referencia apuntaban a /checkout llevan data-ebl-checkout.
 *  - Por defecto van al enlace de compra de ⚙️ Configuración (Impultienda), o al enlace propio del botón.
 *  - Con data-ebl-carrito (opcional, solo para checkout de Shopify) agregan antes la variante al carrito,
 *    sin duplicarla, y muestran los errores en el elemento de error original de la referencia.
 * El aspecto del botón no cambia en ningún caso.
 * También aplica el precio del ebook de ⚙️ Configuración (ver aplicarPrecios).
 */
(function () {
  if (window.EBLCompra) return;

  var enCurso = false;
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

  function enlaceGlobal() {
    var el = document.querySelector('[data-ebl-enlace-compra]');
    return el ? el.getAttribute('data-ebl-enlace-compra') : '';
  }

  function aplicarEnlaces() {
    var url = enlaceGlobal();
    if (!url) return;
    document.querySelectorAll('.ebl [data-ebl-enlace-global]').forEach(function (a) { a.setAttribute('href', url); });
  }

  function mostrarError(link, mensaje) {
    var box = link.parentElement && link.parentElement.querySelector('[data-ebl-error]');
    if (box) { box.textContent = mensaje; box.style.display = 'block'; } else { window.alert(mensaje); }
  }

  function yaEnCarrito(variantId) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return cart.items.some(function (i) { return String(i.variant_id) === String(variantId); }); });
  }

  function agregar(variantId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error(body.description || body.message || 'No se pudo agregar el producto.');
        return body;
      });
    });
  }

  function onClick(ev) {
    var link = ev.target.closest('[data-ebl-checkout]');
    if (!link || !link.closest('.ebl')) return;
    var destino = link.hasAttribute('data-ebl-enlace-global') ? enlaceGlobal() : link.getAttribute('href');
    if (!destino || destino.charAt(0) === '#') {
      ev.preventDefault();
      mostrarError(link, 'Falta configurar el enlace de compra.');
      return;
    }
    if (!link.hasAttribute('data-ebl-carrito')) return; // enlace directo (Impultienda): navegación normal
    ev.preventDefault();
    var src = document.querySelector('[data-ebl-variant-id]');
    var variantId = src && src.getAttribute('data-ebl-variant-id');
    var msg = (document.querySelector('[data-ebl-msg-sin-producto]') || link).getAttribute('data-ebl-msg-sin-producto') || 'No pudimos agregar el producto.';
    if (!variantId) { mostrarError(link, msg); return; }
    if (enCurso) return;
    enCurso = true;
    link.setAttribute('aria-busy', 'true');
    yaEnCarrito(variantId)
      .then(function (esta) { return esta ? null : agregar(variantId); })
      .then(function () { window.location.href = destino; })
      .catch(function (err) {
        enCurso = false;
        link.removeAttribute('aria-busy');
        mostrarError(link, err.message || msg);
      });
  }


  // Precio del ebook principal (⚙️ Configuración). Rellena el precio grande y el resumen de «11 · Oferta y precio»
  // y reemplaza {precio}, {precio_original}, {ahorro} y {descuento} en cualquier texto de la landing.
  var TOKENS = /\{(precio_original|precio|ahorro|descuento)\}/g;

  function num(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }

  function formato(n, sep, dec) {
    var entero = Math.floor(n), cent = Math.round((n - entero) * 100);
    if (cent >= 100) { entero += 1; cent = 0; }
    var s = String(entero).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return cent > 0 ? s + dec + (cent < 10 ? '0' : '') + cent : s;
  }

  function marcarTokens(raiz) {
    var walker = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null), nodos = [], n;
    while ((n = walker.nextNode())) { TOKENS.lastIndex = 0; if (TOKENS.test(n.nodeValue)) nodos.push(n); }
    nodos.forEach(function (nodo) {
      var frag = document.createDocumentFragment(), txt = nodo.nodeValue, ultimo = 0, m;
      TOKENS.lastIndex = 0;
      while ((m = TOKENS.exec(txt))) {
        frag.appendChild(document.createTextNode(txt.slice(ultimo, m.index)));
        var span = document.createElement('span');
        span.setAttribute('data-ebl-token', m[1]);
        frag.appendChild(span);
        ultimo = m.index + m[0].length;
      }
      frag.appendChild(document.createTextNode(txt.slice(ultimo)));
      nodo.parentNode.replaceChild(frag, nodo);
    });
  }

  function aplicarPrecios() {
    document.querySelectorAll('.ebl').forEach(marcarTokens);
    var cfg = document.querySelector('[data-ebl-enlace-compra]');
    var of = document.querySelector('[data-ebl-moneda]');
    var a = function (el, k, d) { var v = el && el.getAttribute(k); return v === null || v === '' ? d : v; };
    var moneda = a(of, 'data-ebl-moneda', '$'), sep = a(of, 'data-ebl-sep-miles', '.'), dec = a(of, 'data-ebl-sep-decimal', ',');
    var precio = num(a(cfg, 'data-ebl-precio', null));
    if (precio === null) precio = num(a(of, 'data-ebl-precio-variante', null));
    var original = num(a(cfg, 'data-ebl-precio-original', null));
    var f = function (n) { return formato(n, sep, dec); };

    if (precio !== null) document.querySelectorAll('.ebl [data-ebl-precio-num]').forEach(function (el) { el.textContent = f(precio); });
    if (original !== null) document.querySelectorAll('.ebl [data-ebl-principal]').forEach(function (el) {
      el.setAttribute('data-ebl-valor', original); el.textContent = f(original);
    });
    document.querySelectorAll('.ebl .aaf-vs-section').forEach(function (sec) {
      var total = 0;
      sec.querySelectorAll('[data-ebl-valor]').forEach(function (el) { total += num(el.getAttribute('data-ebl-valor')) || 0; });
      sec.querySelectorAll('[data-ebl-suma]').forEach(function (el) { el.textContent = f(total); });
      if (precio === null) return;
      var ahorro = total - precio;
      sec.querySelectorAll('[data-ebl-ahorro-total]').forEach(function (el) { el.textContent = f(Math.max(ahorro, 0)); });
      sec.querySelectorAll('[data-ebl-badge]').forEach(function (el) { el.hidden = !(ahorro > 0); });
    });

    var valores = {
      precio: precio !== null ? moneda + f(precio) : '',
      precio_original: original !== null ? moneda + f(original) : '',
      ahorro: precio !== null && original !== null ? moneda + f(Math.max(original - precio, 0)) : '',
      descuento: precio !== null && original ? Math.round((original - precio) / original * 100) + '%' : ''
    };
    document.querySelectorAll('.ebl [data-ebl-token]').forEach(function (el) {
      var v = valores[el.getAttribute('data-ebl-token')];
      el.textContent = v || '{' + el.getAttribute('data-ebl-token') + '}';
    });
  }

  aplicarEnlaces();
  aplicarPrecios();
  document.addEventListener('DOMContentLoaded', aplicarEnlaces);
  document.addEventListener('DOMContentLoaded', aplicarPrecios);
  document.addEventListener('shopify:section:load', aplicarEnlaces);
  document.addEventListener('shopify:section:load', aplicarPrecios);
  document.addEventListener('click', onClick);
  window.EBLCompra = { agregar: agregar, aplicarEnlaces: aplicarEnlaces, aplicarPrecios: aplicarPrecios };
})();
